import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { RequestReportStatusResponse } from 'common/types'
import { REPORT_DICTIONARY } from 'common/types/br/Response.types'
import { TEndpoint, TEntity, TReportType } from 'contexts/app-context/types'

import { queryOptions } from '@tanstack/react-query'

interface GetReportStatusQueryParams {
  endpoint?: TEndpoint
  reportType: TReportType
  userCountry?: string
  userSelectedEntity?: TEntity
  isUSBranch: boolean
}

export const getReportStatusQueryKey = ({
  reportType,
  userCountry,
  userSelectedEntity,
}: Pick<GetReportStatusQueryParams, 'reportType' | 'userCountry' | 'userSelectedEntity'>) => [
  REACT_QUERY_KEYS.REPORT_STATUS,
  reportType,
  userCountry,
  userSelectedEntity,
]

export const getReportStatusQueryOptions = ({
  endpoint,
  reportType,
  userCountry,
  userSelectedEntity,
  isUSBranch,
}: GetReportStatusQueryParams) => {
  const requestEndpoint = endpoint
    ? {
        ...endpoint,
        headers: {
          ...endpoint.headers,
          'x-inter-tipo-solicitacao': REPORT_DICTIONARY[reportType],
        },
      }
    : undefined

  return queryOptions({
    queryKey: getReportStatusQueryKey({ reportType, userCountry, userSelectedEntity }),
    queryFn: () => {
      if (!requestEndpoint) throw new Error('No get report status endpoint available')

      return bridgeRequest<RequestReportStatusResponse>({
        endpoint: requestEndpoint,
        returnAllResponse: false,
        isUSBranch,
      })
    },
    enabled: !!requestEndpoint && !!userCountry && !!userSelectedEntity,
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 6,
  })
}
